/*
    This is where all scenes for this store are fetched, and placed into the Component tree in the form of Router
    Routes, that each lead to Room objects
 */

import React, { Component } from 'react';
import { Redirect, Route } from "react-router-dom";
import PropTypes from 'prop-types';

import Room from './Room.jsx';
import { getSceneIds, getAllSceneInfoDictAsync } from '../../utils/StoreConfigManager.js';
import I18NContext from '../ui/i18next-context/I18NextContext.jsx';
const path = require('path');

class RoomRoutes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstSceneId: '',
            sceneIdDataDict: null,
        };

        getSceneIds()
            .then(sceneIds => this.setState({ firstSceneId: sceneIds[0] }))
            .catch(error => console.error(error));

        getAllSceneInfoDictAsync()
            .then(sceneInfoDict => {
                this.setSceneIdDataDict(sceneInfoDict);
            })
            .catch(error => console.error(error));
    }

    getPath(i18nContext, name) {
        console.log("i18nContext, name ", i18nContext.currentLanguage, name);
        return `/${i18nContext.currentLanguage}/${name}`
    }

    getRedirect(i18nContext) {
        const urlParts = window.location.hash.split("/");
        const lang = i18nContext.currentLanguage;
        const availableLanguages = i18nContext.availableLanguages[0];

        const toRedirectLang = lang || availableLanguages[0]

        if (urlParts.length > 1 && !i18nContext.availableLanguages.includes(urlParts[1])) {
            return <Redirect exact from="/" to={`/${toRedirectLang}/${urlParts[1]}`} />;
        }

        return null;
    }

    isFlatImageSceneCheck(pathName) {
        return !!path.extname(pathName);
    }

    setSceneIdDataDict(sceneInfoDict) {
        const sceneData = {}
        for (const sceneInfo in sceneInfoDict) {
            sceneData[sceneInfo] = sceneInfoDict[sceneInfo];

            const flatScenePath = sceneData[sceneInfo].flat_scene_url ? sceneData[sceneInfo].flat_scene_url.path : '';
            const isFlatImageScene = this.isFlatImageSceneCheck(flatScenePath)
            sceneData[sceneInfo].isFlatImageScene = isFlatImageScene;
        }

        this.setState({ sceneIdDataDict: sceneData });
    }

    render() {
        const { firstSceneId, sceneIdDataDict } = this.state;
        const { i18nContext } = this.props;
        if (!firstSceneId || !sceneIdDataDict) {
            return (<div />);
        }

        const routeRenders = [];
        const firstSceneData = sceneIdDataDict[firstSceneId];

        routeRenders.push(<Route
            key={firstSceneId}
            path={this.getPath(i18nContext, "")}
            exact
            render={props =>
                <Room id={firstSceneId} sceneData={firstSceneData} hideRoomObjects={this.props.hideRoomObjects} loadBlurredImage={true} scenesInfo={sceneIdDataDict} i18nContext={i18nContext} />}
        />);

        for (const [id, data] of Object.entries(sceneIdDataDict)) {
            const name = data['name'];
            let render = <Route
                key={id + '-' + name}
                path={this.getPath(i18nContext, name)}
                exact
                render={props => <Room id={id} sceneData={data} hideRoomObjects={this.props.hideRoomObjects} loadBlurredImage={true} scenesInfo={sceneIdDataDict} i18nContext={i18nContext} />}
            />
            routeRenders.push(render);
        }
        return (
            <React.Fragment>
                {routeRenders}
                {this.getRedirect(i18nContext)}
            </React.Fragment>
        );
    }
}

RoomRoutes.propTypes = {
    hideRoomObjects: PropTypes.bool
};

export default props => (
    <I18NContext.Consumer>
        {i18nContextValues => (
            <RoomRoutes i18nContext={i18nContextValues} {...props} />
        )}
    </I18NContext.Consumer>
);
